import { render } from "./Star.vue?vue&type=template&id=6eda26bb&ts=true"
import script from "./Star.vue?vue&type=script&lang=ts"
export * from "./Star.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__